import { AuthErrorType } from '../models/auth-error-type';
import { authConfigSnapshot } from '../repositories/auth.repository';

/**
 * Internal function to lookup the Auth error message based on the Auth Error Type
 * @param key Auth Error Type
 * @returns The corresponding error message for the Auth Error Type
 */
export const lookUpAuthError = (key: AuthErrorType) => {
  const config = authConfigSnapshot();
  return config.errorMap[key];
};
